module.exports = __webpack_public_path__ + "static/media/plusIcon.5b0d01a1.svg";